
/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file ThreeScene.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import BackgroundImage from './glitch/BackgroundImage.js'
import PostEffect from './glitch/PostEffect.js'
import {EventTypes} from 'starting-blocks'
import * as THREE from 'three'

export default class ThreeScene {
    constructor () {
        this.canvas = document.getElementById('canvas-webgl')
        this.renderer = new THREE.WebGLRenderer({
            antialias: false,
            canvas: this.canvas
        })
        this.renderBack1 = new THREE.WebGLRenderTarget(document.body.clientWidth, window.innerHeight)
        this.scene = new THREE.Scene()
        this.sceneBack = new THREE.Scene()
        this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)
        this.cameraBack = new THREE.PerspectiveCamera(45, document.body.clientWidth / window.innerHeight, 1, 10000)
        this.clock = new THREE.Clock()
        this.isRafInit = false
        this.bgImg = new BackgroundImage()
        this.postEffect = new PostEffect(this.renderBack1.texture)

        this.onResize = this.onResize.bind(this)
        this.onBeforePageShow = this.onBeforePageShow.bind(this)
    }

    init () {
        this.renderer.setSize(document.body.clientWidth, window.innerHeight)
        this.renderer.setClearColor(0x555555, 1.0)
        this.cameraBack.position.set(1000, 1000, 1000)
        this.cameraBack.lookAt(new THREE.Vector3())

        this.bgImg.init(() => {
            this.sceneBack.add(this.bgImg.obj)
            this.scene.add(this.postEffect.obj)
        })

        this.initEvents()
        this.onResize()
    }

    initRaf () {
        if (this.isRafInit) return
        this.isRafInit = true
        this.renderLoop()
    }

    onResize () {
        this.canvas.width = document.body.clientWidth
        this.canvas.height = window.innerHeight
        this.cameraBack.aspect = document.body.clientWidth / window.innerHeight
        this.cameraBack.updateProjectionMatrix()
        this.bgImg.resize()
        this.postEffect.resize()
        this.renderBack1.setSize(document.body.clientWidth, window.innerHeight)
        this.renderer.setSize(document.body.clientWidth, window.innerHeight)
    }

    render () {
        const time = this.clock.getDelta()
        this.renderer.render(this.sceneBack, this.cameraBack, this.renderBack1)
        this.postEffect.render(time)
        this.renderer.render(this.scene, this.camera)
    }

    renderLoop () {
        this.render()
        window.requestAnimationFrame(this.renderLoop.bind(this))
    }

    initEvents () {
        window.addEventListener('resize', this.onResize)
        window.addEventListener(EventTypes.BEFORE_PAGE_SHOW, this.onBeforePageShow)
    }

    /**
     * @param {CustomEvent} e
     */
    onBeforePageShow (e) {
        /**
         * @type {DefaultPage}
         */
        const page = e.detail

        Promise
            .all([this.postEffect.glitchIt(), this.bgImg.loadImage(page.getImage())])
            .then(() => {
                this.bgImg.switchImage()
                this.postEffect.unGlitchIt()
            })
    }
}



// WEBPACK FOOTER //
// ./webpack/js/scene/ThreeScene.js